import React, { useMemo, useState } from "react";
import moment from "moment";
import styles from "./index.module.scss";
import Timer from "../../../stories/common/timer";
import { Sidebar } from "primereact/sidebar";
import InvestorActivity from "../../invesetor-activity";
import Buttonc from "../../../stories/common/button";
import { useNavigate } from "react-router-dom";
import { InvestorBidInitiated } from "../../../utils/inv-exch-amplitude";
import ContactDropdown from "../../../stories/common/flipper-vault-card/contact-dropdown";
import SendPropertyInfo from "../inv-web-card/send-property-info";
// import { formatPhoneNumber } from "../../../utils/utils";
interface InvCardProps {
  id?: string;
  expiryAt: string;
  accountId: string;
  checkoutId: string;
  releasedAt: string;
  accountName: string;
  email: string;
  plainPhone: string;
  propertyId?: string;
  propertySfid?: string;
  accountSfid?: string;
  address: string;
  engmtStatus?: string;
  userName?: string;
  myAccounts?: boolean;
  createdAt: string;
  bidCount?: number;
  portalStatus: string;
  contacts?: Array<{
    id: string;
    name: string;
    sfid: string;
    email: string;
    mobile: string;
  }>;
}

export default function InvCard({
  propertySfid,
  accountSfid,
  address,
  checkoutId,
  accountName,
  expiryAt,
  createdAt,
  releasedAt,
  email,
  plainPhone,
  accountId,
  userName,
  myAccounts = false,
  propertyId,
  bidCount,
  contacts,
  engmtStatus,
  portalStatus
}: InvCardProps) {
  const [isExpired, setIsExpired] = useState(
    moment.utc(expiryAt).isBefore(moment().utc())
  );
  const [contact, setContact] = useState(contacts?.[0]);
  const [showSendPropertyInfo, setShowSendPropertyInfo] = useState(false);
  const navigate = useNavigate();
  const [showReleaseBtn, setShowReleaseBtn] = useState(
    createdAt &&
      -moment.utc(createdAt).diff(moment().utc(), "minutes") <=
        +`${process.env.REACT_APP_RELEASE_TIMER}`
      ? true
      : false
  );
  const [openActivity, setOpenActivity] = useState(false);

  const vaultStatus = useMemo(() => {
    if (releasedAt !== null) {
      return "RELEASED";
    } else if (isExpired && releasedAt === null) {
      return "EXPIRED";
    } else {
      return "ACTIVE";
    }
  }, [releasedAt, isExpired]);

  return (
    <>
      <div className={styles.invCardWrap}>
        <div
          className={`${styles.invCardWrapper} ${
            portalStatus === "Pending Price Cut" ? styles.pendingPriceCut : ""
          }`}
        >
          <div className={styles.invCard}>
            <div className={styles.tagsWrap}>
              <div
                className={`${styles.TAG} ${
                  styles[vaultStatus?.replaceAll(" ", "")]
                }`}
              >
                {!myAccounts && (
                  <>
                    Checkout Status <br />
                  </>
                )}
                <span className={myAccounts ? `${styles.myAccountStatus}` : ""}>
                  {vaultStatus?.toLowerCase()}
                </span>
              </div>

              {/* {!myAccounts && (
              <div
                className={`${styles.TAG} ${
                  styles[engmtStatus?.toLowerCase() || ""]
                }`}
              >
                Engagement Status <br />
                <span>{engmtStatus}</span>
              </div>
            )} */}
            </div>
            <img
              src="/images/inv-list-activity.svg"
              alt=""
              className={vaultStatus === "ACTIVE" ? "" : styles.activityIcon}
              onClick={() => {
                if (vaultStatus === "ACTIVE") setOpenActivity(true);
              }}
            />
            {vaultStatus === "ACTIVE" && (
              <Sidebar
                visible={openActivity}
                position="bottom"
                onHide={() => setOpenActivity(false)}
                className={styles.activityDrawer}
                maskClassName={styles.activityDrawerMask}
              >
                <InvestorActivity
                  acctId={accountId}
                  setOpenActivity={setOpenActivity}
                  entityName={accountName}
                  pubPropertyId={propertyId}
                />
              </Sidebar>
            )}
          </div>
          <div className={styles.invCardDetails}>
            <div className={styles.AccName}>{accountName}</div>
            <div className={styles.AccAddress}>{address}</div>
            <div className={styles.contactInfo}>
              {!myAccounts && (
                <ContactDropdown
                  flipperData={{
                    contacts: contacts,
                    acctSfid: accountSfid,
                    acctId: accountId,
                    propertyId: propertyId,
                    propertySfid: propertySfid
                  }}
                  hideInfo={vaultStatus !== "ACTIVE"}
                  contact={contact}
                  setContact={setContact}
                />
              )}
            </div>
            {myAccounts && portalStatus === "Pending Price Cut" && (
              <div
                className={`${styles.portalStatusMyAccount} ${styles.portalStatus}`}
              >
                <span className={styles.dot}></span>
                {portalStatus}
              </div>
            )}
            {myAccounts && (
              <div className={styles.FlipperVaultCardOwner}>
                <div className={styles.FlipperVaultCardOwnerTitle}>
                  Checked Out By
                </div>
                <div className={styles.FlipperVaultCardOwnerValue}>
                  {userName}
                </div>
              </div>
            )}
          </div>
          {!isExpired && releasedAt === null && (
            <>
              <div className={styles.TimerWrapper}>
                <Timer
                  className={styles.Timer}
                  acctId={accountId}
                  time={expiryAt}
                  setShowReleaseBtn={setShowReleaseBtn}
                  onExpire={() => {
                    setIsExpired(true);
                  }}
                  createdAt={createdAt}
                  classNameTitle={styles.TimerTitle}
                  classNameClock={styles.classNameClock}
                />
                {/* {!myAccounts && (
              <ReleaseBtn
                id={checkoutId}
                ReleaseBtnClassName={styles.ReleaseBtn}
                type="invList"
                disable={!showReleaseBtn && bidCount !== 0}
              />
            )} */}
              </div>
              {!myAccounts && (
                <div className={styles.btnWrap}>
                  <Buttonc
                    type="button"
                    label="Add Bid"
                    size="large"
                    className={styles.AddBid}
                    onClick={() => {
                      InvestorBidInitiated({
                        property_id: propertyId ?? "",
                        property_sfid: propertySfid ?? "",
                        investor_id: accountId,
                        investor_sfid: accountSfid ?? ""
                      });
                      navigate(
                        `/internal/${propertyId}?acctId=${accountId}&bid=true`
                      );
                    }}
                  />
                  <Buttonc
                    className={styles.viewPropertyBtn}
                    type="button"
                    label="Send Property Info"
                    // icon={<img src="/images/home-prop.svg" alt="" />}
                    size="large"
                    onClick={() => {
                      setShowSendPropertyInfo(true);
                    }}
                  />
                </div>
              )}
            </>
          )}
        </div>
        {!myAccounts && portalStatus === "Pending Price Cut" && (
          <div className={styles.portalStatus}>
            <span className={styles.dot}></span>
            {portalStatus}
          </div>
        )}
      </div>
      <SendPropertyInfo
        Visible={showSendPropertyInfo}
        setVisible={setShowSendPropertyInfo}
        pubPropertyId={propertyId}
      />
    </>
  );
}
